import { useCallback } from 'react';
import { Box, Center, Flex, SimpleGrid, Stack } from '@mantine/core';

import { CardRequestStep } from 'types';
import { Button, InputLabel, MonthPicker, NumberInput, SectionLabel, Select, Text, TextInput, YesNoRadioButton } from 'components';

const WorkInformationStep = ({
  form,
  onSubmit,
  options,
  t,
}: CardRequestStep) => {

  const onSubmitWrapper = useCallback(() => {
    onSubmit();
  }, [form.values, options]);

  return (
    <Center>
      <Box w={'80%'}>
        <SimpleGrid cols={{ base: 1, md: 2 }}>
          <Stack>
            <Select
              label={t('input.professionalSituation.label')}
              data={options['professionalSituation'].map(el => (
                { value: el, label: t(`input.professionalSituation.options.${el}`) }
              ))}
              key={form.key('professionalSituation')}
              {...form.getInputProps('professionalSituation')}
              clearable={true}
            />
            <NumberInput
              label={t('input.monthlyNetIncome.label')}
              key={form.key('monthlyNetIncome')}
              {...form.getInputProps('monthlyNetIncome')}
              rightSection={<Text size={'sm'} >{t('currency.switzerland')}</Text>}
              rightSectionWidth={40}
            />
            <YesNoRadioButton
              name={'thirteenthSalary'}
              label={t('input.thirteenthSalary.label')}
              t={t}
              form={form}
            />
            {form.values.maritalStatus === 'MARRIED' ?
              <>
                <NumberInput
                  label={t('input.monthlyNetIncomePartner.label')}
                  key={form.key('monthlyNetIncomePartner')}
                  {...form.getInputProps('monthlyNetIncomePartner')}
                  rightSection={<Text size={'sm'} >{t('currency.switzerland')}</Text>}
                  rightSectionWidth={40}
                />
                <YesNoRadioButton
                  name={'thirteenthSalaryPartner'}
                  label={t('input.thirteenthSalary.partner.label')}
                  t={t}
                  form={form}
                />
              </>
              : undefined}
            <NumberInput
              label={t('input.monthlyRentExpenses.label')}
              key={form.key('monthlyRentExpenses')}
              {...form.getInputProps('monthlyRentExpenses')}
              rightSection={<Text size={'sm'} >{t('currency.switzerland')}</Text>}
              rightSectionWidth={40}
            />
            <NumberInput
              label={t('input.monthlyAlimonyExpenses.label')}
              key={form.key('monthlyAlimonyExpenses')}
              {...form.getInputProps('monthlyAlimonyExpenses')}
              rightSection={<Text size={'sm'} >{t('currency.switzerland')}</Text>}
              rightSectionWidth={40}
            />
          </Stack>
          <Stack>
            {/* <SectionLabel
              label={t('card.workplace')}
              variant={'green'}
            /> */}
            <TextInput
              label={t('input.companyName.label')}
              key={form.key('companyName')}
              {...form.getInputProps('companyName')}
            />
            <Select
              label={t('input.companyCountry.label')}
              data={options['country'].map(el => (
                { value: el, label: t(`input.country.options.${el}`) }
              ))}
              key={form.key('companyCountry')}
              {...form.getInputProps('companyCountry')}
              clearable={true}
            />
            <Box>
              <InputLabel label={t('input.postalCity.label')} />
              <Flex direction={'row'} justify={'space-between'}>
                <TextInput
                  key={form.key('companyPostal')}
                  {...form.getInputProps('companyPostal')}
                  placeholder={t('input.postal.label')}
                  maxLength={4}
                />
                <TextInput
                  key={form.key('companyCity')}
                  {...form.getInputProps('companyCity')}
                  placeholder={t('input.city.label')}
                />
              </Flex>
            </Box>
            <MonthPicker
              label={t('input.companyEmployedAt.label')}
              key={form.key('companyEmployedAt')}
              {...form.getInputProps('companyEmployedAt')}
              minDate={form.values.birthDate}
              maxDate={new Date()}
            />
          </Stack>
        </SimpleGrid>
        <Button mt={'lg'} onClick={onSubmitWrapper}>
          {t('action.next')}
        </Button>
      </Box>
    </Center>
  )
}

export default WorkInformationStep;